<template>
  <div class="fillheight datastore-main-container">
    <v-sheet class="fillheight overflow-hidden">
      <base-serve-table
        ref="table"
        :api="api"
        :headers="headers"
        :params="params"
        :defaultParams="default_params"
        use-grid
        use-scroll-load
        use-top
        grid-row
        use-selected
        v-model="datastore_selected"
      >
        <template #top-left>
          <v-text-field
            v-model="params.search"
            clearable
            dense
            hide-details
            outlined
            placeholder="Tìm kiếm theo tên"
            prepend-inner-icon="mdi-magnify"
            single-line
          />
        </template>
        <template #top-right>
          <div style="width: 100px" class="mr-10">
            <base-button
              block
              type-action="create"
              @click="onCreateItem()"
            ></base-button>
          </div>
        </template>
        <template #grid-item="{ item }">
          <datastore-item
            :value="item"
            @update-item="onUpdateItem(item)"
            @delete-item="onDeleteItem(item)"
          >
            <!-- <div class="d-flex flex-wrap">

            </div> -->
            <div class="d-flex justify-around align-center">
              <div
                :class="item.enabled ? 'mr-3 text--disabled' : 'mr-3 red--text'"
              >
                Vô hiệu
              </div>
              <v-switch
                color="#57AA48"
                class="custom-red ma-0"
                @click="toggleSwitch(item)"
                v-model="item.enabled"
                hide-details
              ></v-switch>
              <div
                :class="
                  !item.enabled ? 'ml-3 text--disabled' : 'ml-3 green--text'
                "
              >
                Kích hoạt
              </div>
            </div>
          </datastore-item>
        </template>
        <template #base-table="data">
          <div v-for="(item, index) in data.items" :key="`test-${index}`">
            {{ item.name }}
          </div>
        </template>
        <template #table-right>
          <DataStoreDetailItem
            :selected="datastore_selected"
            @click:enabled="updateStatus($event, true)"
          ></DataStoreDetailItem>
        </template>
      </base-serve-table>
    </v-sheet>
  </div>
</template>

<script>
import FilterSearch from '@layouts/filter-search.vue'
import DatastoreItem from './datastore-item.vue'
import { API_DATASTORE } from '@api'
import { ConfirmBuilder } from '@utils'
import { mapGetters } from 'vuex'
import { EDIT_TYPE } from '@constant'
import DataStoreDetailItem from './datastore-detail-item.vue'
export default {
  mixins: [],
  components: {
    // FilterSearch,
    DatastoreItem,
    DataStoreDetailItem,
  },
  props: {
    option: { type: Object, default: () => ({ params: {} }) },
    workspace: {},
    id: [String, Number],
  },
  data: (vm) => ({
    default_params: {
      workspace_id: vm.id,
      sort: 'name',
    },
    params: { search: '', inactive: null },
    menus: [
      {
        type: 'update',
        handler: (item) => vm.onUpdateItem(item),
        disabled: (item) => !vm.checkAccess('workspace.update', item),
      },
      {
        type: 'delete',
        handler: (item) => vm.onDeleteItem(item),
        disabled: (item) => !vm.checkAccess('workspace.delete', item),
      },
    ],
    headers: [
      {
        text: 'Tên hiển thị',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        text: 'Ngày tạo',
        align: 'start',
        sortable: true,
        value: 'created_at',
      },
      {
        text: 'Ngày cập nhật',
        align: 'start',
        sortable: true,
        value: 'updated_at',
      },
      {
        trans: 'field.action',
        value: 'action',
        sortable: false,
        width: '150px',
        align: 'center',
      },
    ],
    loading: false,
    resource_headers: [
      {
        trans: 'datastore.layer.name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      {
        trans: 'datastore.layer.action',
        align: 'start',
        sortable: false,
        value: 'action',
      },
    ],
    resource_default_params: {},
    resource_params: { search: '', inactive: null },
    datastore_selected: {},
  }),
  watch: {
    'datastore_select.selected': {
      handler(val) {
        this.datastore_select.items = val.layers
      },
    },
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    api() {
      return API_DATASTORE
    },
  },
  created() {},
  mounted() {},
  methods: {
    async onDeleteItem(item) {
      let confirm = new ConfirmBuilder()
      confirm
        .addMessage('confirm.delete-name')
        .setTitle('confirm.title')
        .setOption({
          params: { name: item.username },
          color: 'error',
        })
        .setType('delete')
      if (await confirm.confirm()) {
        const result = await this.api.destroy(item.id, item)
        if (result.isDone) {
          this.onReset()
          if (item.id == this.datastore_selected.id) {
            this.datastore_selected = {}
          }
        }
        return result
      }
    },
    async updateStatus(item, value) {
      if (item.enable != value) {
        let selected = { ...this.datastore_selected }
        this.api.update(item.id, { enabled: value }).finally(async () => {
          await this.onReset()
          if (item.id == selected.id) {
            this.datastore_selected = { ...selected, enabled: value }
          }
        })
      }
    },
    async toggleSwitch(item) {
      this.api.update(item.id, { enabled: item.enabled }).finally(async () => {
        await this.onReset()
      })
    },
    onCreateItem() {
      this.$emit('click:add-datastore', { type: EDIT_TYPE.CREATE, data: {} })
    },
    onUpdateItem(item) {
      this.$emit('click:add-datastore', { type: EDIT_TYPE.UPDATE, data: item })
    },
    onReset() {
      this.$refs.table.reload()
    },
  },
}
</script>
<style scoped>
.custom-red {
  color: #f36f56;
}
.scroll {
  height: 800px;
  overflow-y: scroll;
}
@media only screen and (min-width: 600px) {
  .datastore-main-container {
    max-height: calc(100vh - 60px - 40px - 45px - 40px - 150px) !important;
    padding-bottom: 80px;
  }
}
</style>
